var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 24, lg: 24 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "header_title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("kjrk"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nav_grid" },
                  _vm._l(_vm.nav_list, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "nav_grid_item",
                        on: {
                          click: function ($event) {
                            return _vm.navigatorTo(item.url)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pic_badge",
                            style: { backgroundColor: item.bgColor },
                          },
                          [
                            _c("span", {
                              staticClass: "iconfont",
                              class: item.icon,
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(item.title))]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 24, lg: 24 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c("div", { staticClass: "header_title" }, [
                  _vm._v(_vm._s(_vm.$t("jysj"))),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "totallist" }, [
                  _c("li", [
                    _c("span", { staticClass: "total-after afters1" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.viewData.today_recharge_price) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n              " +
                          _vm._s(_vm.$t("jrcz")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters2" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.viewData.today_withdraw_price) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("jrtx")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters3" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.viewData.today_profit_and_loss_price) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("jryk")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters4" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.viewData.today_first_recharge_price) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                 " +
                          _vm._s(_vm.$t("jrsc")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters5" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.viewData.yesterday_recharge_price) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("zrcz")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters6" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.viewData.yesterday_withdraw_price) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("zrtx")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters7" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.viewData.yesterday_profit_and_loss_price) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n               " +
                          _vm._s(_vm.$t("zryk")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters8" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.viewData.yesterday_first_recharge_price) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("zrsc")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters9" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.viewData.current_month_recharge_price) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("bysc")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters10" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.viewData.current_month_withdraw_price) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("bytx")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters11" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.viewData.current_month_profit_and_loss_price
                          ) +
                          "\n             "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n               " +
                          _vm._s(_vm.$t("byyk")) +
                          "\n             "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", { staticClass: "total-after afters12" }),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-num" }, [
                      _vm._v(
                        "\n                   " +
                          _vm._s(_vm.viewData.current_month_first_recharge) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "total-name" }, [
                      _vm._v(
                        " \n                " +
                          _vm._s(_vm.$t("bysc")) +
                          "\n              "
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }